module.exports = __webpack_public_path__ + "img/deers.316eea2e.png";